/**
 * Auto-generated at build time — do not edit manually.
 */
export const APP_VERSION = "v2.8.2";
export const BUILD_DATE  = "02 Nov 2026 15:15";
export const VERSION_LABEL = `${APP_VERSION} · ${BUILD_DATE}`;
